/**
 * show a list of my development devices for a device owner
 */
import _ from 'underscore';
import Radio from 'backbone.radio';
import strings_specific from 'amdi18n-loader!@/nls/device_group_list';
import strings_common from 'amdi18n-loader!@/nls/common';
    var globalCh = Radio.channel('global');
    var strings = _.extend({}, strings_common, strings_specific);

    var title = "My Development Devices";

    var columns = [{
            name: '',
            class_name: 'select',
            sortable: false,
            select_all: true
        }, {
            name: strings.device_id,
            class_name: 'name',
            sortable: false,
        }, {
            name: 'Type',
            class_name: 'devicegroup-type',
            sortable: false,
        }, {
            name: 'Status',
            class_name: 'status',
            sortable: false,
        }, {
            name: strings.account,
            class_name: 'account',
            sortable: false
        }, {
            name: 'Product',
            class_name: 'product',
            sortable: false
        }, {
            name: strings.groups,
            class_name: 'group',
            sortable: false
        }, {
            name: 'Last Enrolled',
            class_name: 'enrolled',
            sortable: false,
            sort_by: 'last_enrolled_at'
        }, {
            name: 'Manage'
        }
    ];

    var child_view_options = { show: {
        type: true,
        rel_owner: false,
        rel_account: true,
        rel_product: true,
        rel_devicegroup: true
    }};

    function show_my_development_devices(owner) {
        function show_devices() {
            var show_blinkup = true;
            globalCh.request(
                'show_devices',
                { owner: owner },
                columns,
                title,
                child_view_options,
                show_blinkup
            );
        }

        owner.load().then(show_devices);
    }

    export default show_my_development_devices;

 
